import { createDynamicColumnKey, createDynamicCountSumKey } from './create-column-keys'
import { Entity } from './types'
import { ColsGroupedDataType } from 'app/dataTypes/reports/data/common/subsidies/grouped'

const headerCells = {
  [Entity.Date]: 'Дата',
  [Entity.DateGhost]: '',
  [Entity.Klasses]: 'Классы',
  [Entity.DayCares]: 'ГПД',
  [Entity.Count]: 'Кол-во',
  [Entity.Sum]: 'Сумма',
  [Entity.TotalRowGhost]: '',
  [Entity.SumRow]: 'Сумма',
  [Entity.CountRow]: 'Кол-во',
  [Entity.TotalRow]: 'Всего',
}

export const createHeaderCells = (cols: ColsGroupedDataType) => {
  return Object.keys(cols).reduce(
    (acc, key) => {
      const colKey = key as keyof ColsGroupedDataType
      cols[colKey].forEach((item) => {
        const titleKey = createDynamicColumnKey(colKey, item)
        acc[titleKey] = item
        acc[createDynamicCountSumKey(colKey, item, 'count')] = headerCells[Entity.Count]
        acc[createDynamicCountSumKey(colKey, item, 'sum')] = headerCells[Entity.Sum]
      })
      return acc
    },
    { ...headerCells },
  )
}
